import itemToBag from "./itemToBag";
import clientConfigurationProvider from "../../providers/clientConfigurationProvider";
const { addItemToBagRequestTimeout: requestTimeout } =
  clientConfigurationProvider();

const toBagOperation = (sdkInstance, item) => sdkInstance.addVariant(item);

export default itemToBag({ toBagOperation, requestTimeout });
